(function () {
  const instances = new Map();

  function wireVideoControls(section) {
    section.querySelectorAll(".swiper-slide").forEach((slide) => {
      const video = slide.querySelector(".video-card__video");
      const button = slide.querySelector(".video-card__play");
      if (!video || !button) return;

      video.controls = false;
      video.style.pointerEvents = "none";

      const showBtn = () => {
        button.style.display = "";
        video.controls = false;
        video.style.pointerEvents = "none";
      };
      const hideBtn = () => {
        button.style.display = "none";
        video.controls = true;
        video.style.pointerEvents = "auto";
      };

      if (video.paused) showBtn();
      else hideBtn();

      button.addEventListener("click", () => {
        video.setAttribute("playsinline", "");
        video.setAttribute("webkit-playsinline", "");
        video.play().catch(() => {});
      });

      video.addEventListener("play", hideBtn);
      video.addEventListener("pause", showBtn);
      video.addEventListener("ended", showBtn);
    });
  }

  function pauseAllVideos(section) {
    section.querySelectorAll(".video-card__video").forEach((v) => {
      if (!v.paused) v.pause();
    });
  }

  function initSection(section) {
    const isStacked = section.dataset.stackCards === "true";
    const swiperEl = section.querySelector(".mySwiper");
    if (!swiperEl) return;

    if (instances.has(section)) {
      instances.get(section).destroy(true, true);
      instances.delete(section);
    }

    const prev = section.querySelector(".video-swiper-button-prev");
    const next = section.querySelector(".video-swiper-button-next");
    const pag = section.querySelector(".video-swiper-pagination");

    if (isStacked) {
      if (prev) prev.style.display = "";
      if (next) next.style.display = "";
      if (pag) pag.style.display = "none";
    } else {
      if (prev) prev.style.display = "none";
      if (next) next.style.display = "none";
      if (pag) pag.style.display = "";
    }

    const config = isStacked
      ? {
          effect: "cards",
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: 1,
          navigation: prev && next ? { nextEl: next, prevEl: prev } : false,
          pagination: false,
          cardsEffect: {
            rotate: true,
            perSlideRotate: 1,
            perSlideOffset: 1,
            slideShadows: false,
          },
          on: {
            setTranslate(sw) {
              sw.slides.forEach((slide) => {
                slide.style.transform = slide.style.transform.replace(
                  /translate3d\(([^,]+),\s*([^,]+),\s*[^)]+\)/,
                  "translate3d($1, $2, 0px)"
                );
              });
            },
          },
        }
      : {
          slidesPerView: "auto",
          spaceBetween: 20,
          slidesOffsetBefore: 20,
          slideToClickedSlide: true,
          navigation: false,
          pagination: pag ? { el: pag, clickable: true } : false,
        };

    const instance = new Swiper(swiperEl, config);
    instances.set(section, instance);

    wireVideoControls(section);

    instance.on("slideChangeTransitionStart", () => {
      section.querySelectorAll(".video-card__video").forEach((v) => {
        if (!v.paused) v.pause();
      });
      section
        .querySelectorAll(".video-card__play")
        .forEach((b) => (b.style.display = ""));
    });
  }

  function initAll() {
    document.querySelectorAll(".video-swiper").forEach(initSection);
  }

  document.addEventListener("DOMContentLoaded", initAll);

  // Debounced resize re-init
  let resizeTimeout;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initAll, 300);
  });
})();
